import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { getApiErrorMessage, toApiError } from '../utils';

export const useDeleteSoilAnalysis = () => {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation({
		mutationFn: async (id: string) => {
			try {
				return (await api.delete(`/soil-analysis/delete/${id}`, {
					params: { forBinding },
				})).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao deletar análise de solo');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['soilAnalysis'] });
		},
		onError: (error) =>
			console.error(
				'Erro ao deletar análise de solo:',
				getApiErrorMessage(error, 'Erro ao deletar análise de solo')
			),
	});
};
